import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ComingSoon from "../components/ComingSoon";

function EndpointManagementList() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ComingSoon
        title="UDS Endpoint Management"
        description="Unser Endpoint Management System befindet sich aktuell in der Testphase und ist nur für ausgewählte Kunden verfügbar. Mit UDS EPM verwalten Sie alle Ihre Endgeräte zentral, automatisieren Updates und stellen die Sicherheit Ihrer IT-Infrastruktur sicher. Die öffentliche Version wird in Kürze verfügbar sein."
        productUrl="https://www.unitas.cloud/produkte/epm"
      />
      <Footer />
    </DashboardLayout>
  );
}

export default EndpointManagementList;
